import { motion } from 'framer-motion';
import React from 'react';

interface LoginTransitionProps {
  children: React.ReactNode;
}

const loginVariants = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  },
};

const loginTransition = {
  type: 'tween',
  ease: 'easeInOut',
  duration: 0.3,
};

const LoginTransition: React.FC<LoginTransitionProps> = ({ children }) => {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={loginVariants}
      transition={loginTransition}
    >
      {children}
    </motion.div>
  );
};

export default LoginTransition; 